import { GroundType } from 'models/ground';
import React from 'react';
import { Group, Line } from 'react-konva';
import {
  DEFAULT_PITCH_LINE_COLOR,
  DEFAULT_PITCH_STROKEWIDTH,
} from '../constants';
import {
  rotate, flipPoint, computeAngle,
  calculateRealWorldMeter
} from '../utils';
import Vertices from '../Vertices';
import { GroundGeometry } from '../../../../types/webPlayer';

export default function Tennis(props: {
  groundData: GroundType;
  scale: number;
  vertices: boolean;
  groundGeometry: GroundGeometry;
}) {
  const { groundData, scale, vertices, groundGeometry } = props;

  const dataScale = scale / groundGeometry.scale;

  let vertexA = {
    x:
      rotate(flipPoint({ x: groundData.vertexAX?.value, y: groundData.vertexAY?.value }, groundData), computeAngle(groundData)).x
      * scale,
    y:
      rotate(flipPoint({ x: groundData.vertexAX?.value, y: groundData.vertexAY?.value }, groundData), computeAngle(groundData)).y
      * scale,
  };
  let vertexC = {
    x:
      rotate(flipPoint({ x: groundData.vertexCX?.value, y: groundData.vertexCY?.value }, groundData), computeAngle(groundData)).x
      * scale,
    y:
      rotate(flipPoint({ x: groundData.vertexCX?.value, y: groundData.vertexCY?.value }, groundData), computeAngle(groundData)).y
      * scale,
  };

  if (vertexA.x > vertexC.x) {
    const swap = vertexC;
    vertexC = vertexA;
    vertexA = swap;
  }

  const width = vertexC.x - vertexA.x;
  const height = vertexC.y - vertexA.y;
  const vertexCXValue = groundData.vertexCX?.value;
  const m = calculateRealWorldMeter(width, vertexCXValue);

  /** HORIZONTAL MEASURES */
  const serviceLineX = 5.48 * m
  const netX = 24 / 2 * m

  /** VERTICAL MEASURES */
  const baselineY = 8.23 * m
  const centerMarkY = 11 / 2 * m
  const singlesSidelineY = 1.35 * m

  return (
    <Group scaleX={dataScale} scaleY={dataScale}>
  {vertices ? <Vertices A={vertexA} C={vertexC} /> : null}

  {/* OUTER COURT (DOUBLES) */}
  <Line
    fill={groundData.groundSurfaceColor ? groundData.groundSurfaceColor : '#00000000'}
    points={[vertexA.x, vertexA.y, vertexC.x, vertexA.y, vertexC.x, vertexC.y, vertexA.x, vertexC.y]}
    stroke={DEFAULT_PITCH_LINE_COLOR}
    strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
    closed
  />

  {/* SINGLES SIDELINES */}
  <Line
    points={[
      vertexA.x, vertexA.y - 1.37 * m,
      vertexC.x, vertexA.y - 1.37 * m
    ]}
    stroke={DEFAULT_PITCH_LINE_COLOR}
    strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
  />
  <Line
    points={[
      vertexA.x, vertexC.y + 1.37 * m,
      vertexC.x, vertexC.y + 1.37 * m
    ]}
    stroke={DEFAULT_PITCH_LINE_COLOR}
    strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
  />

  {/* NET */}
  <Line
    points={[
      width / 2, vertexA.y,
      width / 2, vertexC.y
    ]}
    stroke={DEFAULT_PITCH_LINE_COLOR}
    strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
  />

  {/* SERVICE LINES */}
  <Line
    points={[
      vertexA.x + 5.48 * m, vertexA.y - 1.37 * m,
      vertexA.x + 5.48 * m, vertexC.y + 1.37 * m,
    ]}
    stroke={DEFAULT_PITCH_LINE_COLOR}
    strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
  />
  <Line
    points={[
      vertexC.x - 5.48 * m, vertexA.y - 1.37 * m,
      vertexC.x - 5.48 * m, vertexC.y + 1.37 * m,
    ]}
    stroke={DEFAULT_PITCH_LINE_COLOR}
    strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
  />

  {/* CENTER SERVICE LINE */}
  <Line
    points={[
        vertexA.x + 5.48 * m, height / 2,
        vertexC.x - 5.48 * m, height / 2
    ]}
    stroke={DEFAULT_PITCH_LINE_COLOR}
    strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
  />

  {/* CENTER MARKS */}
  <Line
    points={[
      vertexA.x, height / 2,
      vertexA.x + 0.2 * m, height / 2
    ]}
    stroke={DEFAULT_PITCH_LINE_COLOR}
    strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
  />
  <Line
    points={[
      vertexC.x, height / 2,
      vertexC.x - 0.2 * m, height / 2
    ]}
    stroke={DEFAULT_PITCH_LINE_COLOR}
    strokeWidth={DEFAULT_PITCH_STROKEWIDTH}
  />
</Group>
  );
}
